export const NEWS__PERMISSIONS = {
  NEWS: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie aktualnościami',
      NONE: {
        dbName: 'NEWS__NEWS__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania aktualnościami na stronie marketingowej.'
      },
      ENABLED: {
        dbName: 'NEWS__NEWS__MANAGE__ENABLED',
        name: 'Możliwość zarządzania aktualnościami',
        description: 'Możliwość zarządzania aktualnościami na stronie marketingowej.'
      }
    }
  }
} as const
